import React from 'react';
import {
  FilterInputComponent,
  IconFilter,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

export default () => {
  return (
    <IconFilter
      autoFocus
      name="owner"
      as={FilterInputComponent}
      hasClearButton={false}
      hasApplyButton={false}
    />
  );
};
